// extracted by mini-css-extract-plugin
export var noSpinners = "_ot-6";
export var percentageInput = "_ot-7";
export var variantColor1 = "_ot-0";
export var variantColor2 = "_ot-1";
export var variantColor3 = "_ot-2";
export var variantColor4 = "_ot-3";
export var variantColor5 = "_ot-4";
export var variantColor6 = "_ot-5";